export default __webpack_public_path__ + "46d5166536e893f70cad5c0df80cdcc5.png";